export default __webpack_public_path__ + "static/media/ashpika.15add7b7.png";